import React, { useEffect, useRef } from 'react';
export function TimelineSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.1
    });
    const reveals = sectionRef.current?.querySelectorAll('.reveal');
    reveals?.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} className="py-20 px-4" style={{
    background: 'linear-gradient(160deg, #4A5A2E 0%, #5C6B3A 50%, #4A5A2E 100%)'
  }} data-id="element-271">
      <div className="max-w-3xl mx-auto" data-id="element-272">
        <div className="text-center mb-14" data-id="element-273">
          <h2 className="reveal font-playfair text-4xl md:text-5xl font-bold mb-4" style={{
          color: 'var(--color-cream)'
        }} data-id="element-274">
            Tu Transformación en 7 Días
          </h2>
          <p className="reveal reveal-delay-1 font-lato text-lg" style={{
          color: 'rgba(253, 248, 240, 0.75)'
        }} data-id="element-275">
            Día a día, paso a paso
          </p>
        </div>

        {/* Progress bar */}
        <div className="reveal reveal-delay-1 rounded-full h-2 mb-12 overflow-hidden" style={{
        background: 'rgba(253, 248, 240, 0.15)'
      }} data-id="element-276">
          <div className="h-full rounded-full" style={{
          width: '100%',
          background: 'linear-gradient(90deg, #D4A853 0%, #E8C47A 50%, #D4A853 100%)',
          boxShadow: '0 0 10px rgba(212, 168, 83, 0.5)'
        }} data-id="element-277" />
        </div>

        {/* Timeline */}
        <div className="relative" data-id="element-278">
          {/* Vertical line */}
          <div className="absolute left-8 top-0 bottom-0 w-0.5 hidden md:block" style={{
          background: 'rgba(212, 168, 83, 0.3)'
        }} data-id="element-279" />

          <div className="space-y-8" data-id="element-280">
            {/* Day 1 */}
            <div className="reveal reveal-delay-1 flex items-start gap-6" data-id="element-281">
              <div className="flex-shrink-0 w-16 h-16 rounded-full flex flex-col items-center justify-center shadow-lg z-10" style={{
              background: 'linear-gradient(135deg, #D4A853, #E8C47A)',
              boxShadow: '0 4px 20px rgba(212, 168, 83, 0.4)'
            }} data-id="element-282">
                <span className="font-lato text-xs font-black" style={{
                color: 'var(--color-dark)'
              }} data-id="element-283">
                  DÍA
                </span>
                <span className="font-playfair text-xl font-black" style={{
                color: 'var(--color-dark)'
              }} data-id="element-284">
                  1
                </span>
              </div>
              <div className="flex-1 rounded-2xl p-5" style={{
              background: 'rgba(253, 248, 240, 0.08)',
              border: '1px solid rgba(212, 168, 83, 0.2)'
            }} data-id="element-285">
                <h3 className="font-playfair text-lg font-bold mb-1" style={{
                color: 'var(--color-gold)'
              }} data-id="element-286">
                  Kit armado. Foto inicial.
                </h3>
                <p className="font-lato text-sm" style={{
                color: 'rgba(253, 248, 240, 0.75)'
              }} data-id="element-287">
                  Compras los 8 ingredientes en Mercadona. Haces el test patch.
                  Tomas tu foto de referencia. El protocolo comienza esta noche.
                </p>
              </div>
            </div>

            {/* Day 3 */}
            <div className="reveal reveal-delay-2 flex items-start gap-6" data-id="element-288">
              <div className="flex-shrink-0 w-16 h-16 rounded-full flex flex-col items-center justify-center shadow-lg z-10" style={{
              background: 'linear-gradient(135deg, #D4A853, #E8C47A)',
              boxShadow: '0 4px 20px rgba(212, 168, 83, 0.4)'
            }} data-id="element-289">
                <span className="font-lato text-xs font-black" style={{
                color: 'var(--color-dark)'
              }} data-id="element-290">
                  DÍA
                </span>
                <span className="font-playfair text-xl font-black" style={{
                color: 'var(--color-dark)'
              }} data-id="element-291">
                  3
                </span>
              </div>
              <div className="flex-1 rounded-2xl p-5" style={{
              background: 'rgba(253, 248, 240, 0.08)',
              border: '1px solid rgba(212, 168, 83, 0.2)'
            }} data-id="element-292">
                <h3 className="font-playfair text-lg font-bold mb-1" style={{
                color: 'var(--color-gold)'
              }} data-id="element-293">
                  Hidratación notoria. Patas de gallo más suaves.
                </h3>
                <p className="font-lato text-sm" style={{
                color: 'rgba(253, 248, 240, 0.75)'
              }} data-id="element-294">
                  Los liposomas naturales empiezan a penetrar. Tu piel se ve más
                  hidratada, las líneas finas alrededor de los ojos se suavizan
                  visiblemente.
                </p>
              </div>
            </div>

            {/* Day 5 */}
            <div className="reveal reveal-delay-3 flex items-start gap-6" data-id="element-295">
              <div className="flex-shrink-0 w-16 h-16 rounded-full flex flex-col items-center justify-center shadow-lg z-10" style={{
              background: 'linear-gradient(135deg, #D4A853, #E8C47A)',
              boxShadow: '0 4px 20px rgba(212, 168, 83, 0.4)'
            }} data-id="element-296">
                <span className="font-lato text-xs font-black" style={{
                color: 'var(--color-dark)'
              }} data-id="element-297">
                  DÍA
                </span>
                <span className="font-playfair text-xl font-black" style={{
                color: 'var(--color-dark)'
              }} data-id="element-298">
                  5
                </span>
              </div>
              <div className="flex-1 rounded-2xl p-5" style={{
              background: 'rgba(253, 248, 240, 0.08)',
              border: '1px solid rgba(212, 168, 83, 0.2)'
            }} data-id="element-299">
                <h3 className="font-playfair text-lg font-bold mb-1" style={{
                color: 'var(--color-gold)'
              }} data-id="element-300">
                  Entrecejo relleno 30%. Piel más firme.
                </h3>
                <p className="font-lato text-sm" style={{
                color: 'rgba(253, 248, 240, 0.75)'
              }} data-id="element-301">
                  Los mensajeros regeneradores activan la síntesis de colágeno.
                  Las arrugas de expresión se rellenan desde dentro. Firmeza
                  real, no solo hidratación.
                </p>
              </div>
            </div>

            {/* Day 7 */}
            <div className="reveal reveal-delay-4 flex items-start gap-6" data-id="element-302">
              <div className="flex-shrink-0 w-16 h-16 rounded-full flex flex-col items-center justify-center shadow-lg z-10" style={{
              background: 'linear-gradient(135deg, #C4714A, #D4A853)',
              boxShadow: '0 4px 20px rgba(196, 113, 74, 0.5)'
            }} data-id="element-303">
                <span className="font-lato text-xs font-black" style={{
                color: 'white'
              }} data-id="element-304">
                  DÍA
                </span>
                <span className="font-playfair text-xl font-black" style={{
                color: 'white'
              }} data-id="element-305">
                  7
                </span>
              </div>
              <div className="flex-1 rounded-2xl p-5" style={{
              background: 'rgba(212, 168, 83, 0.1)',
              border: '2px solid rgba(212, 168, 83, 0.4)'
            }} data-id="element-306">
                <h3 className="font-playfair text-xl font-bold mb-1" style={{
                color: 'var(--color-gold)'
              }} data-id="element-307">
                  Luminosidad + firmeza. Foto comparativa. ✨
                </h3>
                <p className="font-lato text-sm" style={{
                color: 'rgba(253, 248, 240, 0.85)'
              }} data-id="element-308">
                  Compara las fotos. El glow español auténtico que buscabas está
                  ahí. Piel firme, luminosa, descansada. Sin cirugías. Sin 80€
                  en serums.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}